import {
  Autocomplete,
  Box,
  CircularProgress,
  InputAdornment,
  Pagination,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState, useMemo } from "react";
import CustomPagination from "../CustomPagination";
import { authHeader } from "../../comman/MainFunction";
import { deCryptFun, enCryptFun } from "../../comman/CustomFunction";
import API from "../../comman/API";
import moment from "moment";
import { GET_PROJECT_ACTIVITY_TABLE } from "../../../constants/ApiRoute";
import sortupdownarrowIcon from "../../../images/sort_up_down_arrow.svg";
import sortuparrowIcon from "../../../images/sort_up_arrow.svg";
import sortdownarrowIcon from "../../../images/sort_down_arrow.svg";
import NoRecordFound from "../../comman/NoRecordFound";

export default function ProjectActivityTable(props) {
  const { customerTab } = props;
  const [sortedData, setSortedData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = useState(1);
  const rowsPerPage = 5;
  const [totalPages, setTotalPages] = useState(0);
  const [sortConfig, setSortConfig] = useState({
    key: "LogDateTime",
    direction: "asc",
  });
  const [orderBy, setOrderBy] = useState("");
  const [order, setOrder] = useState("");

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleSearchChange = (event, value) => {
    setSearchQuery(value);
    setPage(1); // Reset to page 1 when search query changes
  };

  const fieldsToSearch = [
    "User",
    "Description",
    "LogDateTime",
    "LogTypeDescription",
    "TargetName",
  ];

  const getProjectActivityDetails = async (custId) => {
    setLoading(true);
    let data = {
      projectId: customerTab?.projectId ? customerTab?.projectId : custId,
      sort: order,
      orderBy: orderBy,
    };
    const config = {
      method: "GET",
      url: GET_PROJECT_ACTIVITY_TABLE,
      headers: authHeader(),
      params: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };
    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      const { status, data } = parsedResponse;
      if (status === "Success") {
        setSortedData(data);
      }
      setLoading(false);
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
      }
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getProjectActivityDetails(customerTab.projectId);
  }, [customerTab, order, orderBy]);

  // Group data by TargetName
  const groupedData = sortedData.reduce((acc, item) => {
    const key = item.TargetName;
    if (!acc[key]) {
      acc[key] = [];
    }
    acc[key].push(item);
    return acc;
  }, {});

  // Flatten grouped data
  const flattenedArray = Object.entries(groupedData).flatMap(([key, items]) => {
    return items.map((item) => ({
      ...item,
      TargetName: key,
    }));
  });

  const filteredData = flattenedArray.filter((item) =>
    fieldsToSearch.some((field) => {
      let fieldValue = item[field];

      // Debugging LogDateTime formatting
      if (field === "LogDateTime" && fieldValue) {
        fieldValue = moment
          .utc(new Date(fieldValue))
          .format("MM/DD/YYYY h:mm:ss A");
        console.log(`Formatted LogDateTime for Search: ${fieldValue}`);
      }

      return (
        fieldValue &&
        String(fieldValue).toLowerCase().includes(searchQuery.toLowerCase())
      );
    })
  );

  // Implement sorting logic
  // const sortedAndFilteredData = useMemo(() => {
  //   let sortableItems = [...filteredData];
  //   if (sortConfig !== null) {
  //     sortableItems.sort((a, b) => {
  //       if (a[sortConfig.key] < b[sortConfig.key]) {
  //         return sortConfig.direction === "asc" ? -1 : 1;
  //       }
  //       if (a[sortConfig.key] > b[sortConfig.key]) {
  //         return sortConfig.direction === "asc" ? 1 : -1;
  //       }
  //       return 0;
  //     });
  //   }
  //   return sortableItems;
  // }, [filteredData, sortConfig]);

  useEffect(() => {
    setTotalPages(Math.ceil(filteredData.length / rowsPerPage));
  }, [filteredData]);

  // Paginate sorted and filtered data
  const paginatedData = filteredData.slice(
    (page - 1) * rowsPerPage,
    (page - 1) * rowsPerPage + rowsPerPage
  );

  const handleSort = (property) => {
    const isAsc = orderBy === property && order === "asc";

    let orderValue = isAsc ? "desc" : "asc";

    setOrder(orderValue);
    setOrderBy(property);

    if (order === "desc") {
      setOrder("");
      setOrderBy("");
    }

    if (orderBy != property) {
      setOrder("asc");
      setOrderBy(property);
    }

    setPage(1);
    // setSortClickedTime(new Date().toLocaleString());

    // setSortConfig((prevState) => ({
    //   key,
    //   direction: prevState.direction === "asc" ? "desc" : "asc",
    // }));
  };

  const getSortIcon = (orderByValue) => {
    if (orderBy === orderByValue) {
      return order === "asc" ? (
        <img src={sortuparrowIcon} className="sort-table-icon-up-down" />
      ) : (
        <img src={sortdownarrowIcon} className="sort-table-icon-up-down" />
      );
    } else {
      return <img src={sortupdownarrowIcon} className="sort-table-icon-both" />;
    }
  };

  return (
    <div>
      <Stack
        sx={{ mb: "20px" }}
        direction={{ xs: "column", sm: "row", md: "row" }}
        alignItems={{ xs: "baseline", sm: "center", md: "center" }}
        justifyContent="space-between"
      >
        <Autocomplete
          sx={{ maxWidth: "265px", width: "100%" }}
          freeSolo
          id="free-solo-2-demo"
          disableClearable
          startAdornment={
            <InputAdornment position="start">
              <span className="material-symbols-outlined">search</span>
            </InputAdornment>
          }
          options={[]}
          onInputChange={handleSearchChange}
          renderInput={(params) => (
            <TextField
              placeholder="Search"
              {...params}
              InputProps={{
                ...params.InputProps,
                type: "search",
              }}
            />
          )}
        />
      </Stack>
      <TableContainer sx={{ boxShadow: "none" }} component={Paper}>
        <Table
          // sx={{ minWidth: 650 }}
          aria-label="simple table"
        >
          <TableHead>
            <TableRow>
              <TableCell>
                <TableSortLabel
                  active={orderBy === "LogDateTime"}
                  direction={orderBy === "LogDateTime" ? order : "asc"}
                  onClick={() => handleSort("LogDateTime")}
                  IconComponent={() => getSortIcon("LogDateTime")}
                  style={orderBy === "LogDateTime" ? { color: "#007fff" } : {}}
                  // active={sortConfig.key === "LogDateTime"}
                  // direction={
                  //   sortConfig.key === "LogDateTime"
                  //     ? sortConfig.direction
                  //     : "asc"
                  // }
                  // onClick={() => handleSort("LogDateTime")}
                >
                  Date
                </TableSortLabel>
              </TableCell>
              <TableCell>
                <TableSortLabel
                  active={orderBy === "User"}
                  direction={orderBy === "User" ? order : "asc"}
                  onClick={() => handleSort("User")}
                  IconComponent={() => getSortIcon("User")}
                  style={orderBy === "User" ? { color: "#007fff" } : {}}
                  // active={sortConfig.key === "User"}
                  // direction={
                  //   sortConfig.key === "User" ? sortConfig.direction : "asc"
                  // }
                  // onClick={() => handleSort("User")}
                >
                  User
                </TableSortLabel>
              </TableCell>
              <TableCell>
                <TableSortLabel
                  active={orderBy === "LogTypeDescription"}
                  direction={orderBy === "LogTypeDescription" ? order : "asc"}
                  onClick={() => handleSort("LogTypeDescription")}
                  IconComponent={() => getSortIcon("LogTypeDescription")}
                  style={
                    orderBy === "LogTypeDescription" ? { color: "#007fff" } : {}
                  }
                  // active={sortConfig.key === "LogTypeDescription"}
                  // direction={
                  //   sortConfig.key === "LogTypeDescription"
                  //     ? sortConfig.direction
                  //     : "asc"
                  // }
                  // onClick={() => handleSort("LogTypeDescription")}
                >
                  Type
                </TableSortLabel>
              </TableCell>
              <TableCell>
                <TableSortLabel
                  active={orderBy === "Description"}
                  direction={orderBy === "Description" ? order : "asc"}
                  onClick={() => handleSort("Description")}
                  IconComponent={() => getSortIcon("Description")}
                  style={orderBy === "Description" ? { color: "#007fff" } : {}}
                  // active={sortConfig.key === "Description"}
                  // direction={
                  //   sortConfig.key === "Description"
                  //     ? sortConfig.direction
                  //     : "asc"
                  // }
                  // onClick={() => handleSort("Description")}
                >
                  Description
                </TableSortLabel>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={4} align="center">
                  <CircularProgress disableShrink />
                </TableCell>
              </TableRow>
            ) : paginatedData.length > 0 ? (
              paginatedData.map((val, index) => (
                <React.Fragment key={index}>
                  {index === 0 ||
                  paginatedData[index - 1].TargetName !== val.TargetName ? (
                    <TableRow>
                      <TableCell colSpan={4} sx={{ padding: "0px !important" }}>
                        <Box
                          className="datebox-title"
                          sx={{
                            padding: "13px !important",
                            borderRadius: "0px",
                          }}
                        >
                          <Typography>{val.TargetName}</Typography>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ) : null}
                  <TableRow>
                    <TableCell>
                      {val.LogDateTime
                        ? moment
                            .utc(new Date(val.LogDateTime))
                            .format("MM/DD/YYYY h:mm:ss A")
                        : "-"}
                    </TableCell>
                    <TableCell>{val.User ? val.User : "-"}</TableCell>
                    <TableCell>
                      {val.LogTypeDescription ? val.LogTypeDescription : "-"}
                    </TableCell>
                    <TableCell sx={{ wordBreak: "break-word" }}>
                      {val.Description ? val.Description : "-"}
                    </TableCell>
                  </TableRow>
                </React.Fragment>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={4} align="center">
                  {/* <Typography>No Record Found</Typography> */}
                  <NoRecordFound />
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
        {filteredData.length > 0 && (
          <Pagination
            sx={{ mt: "13.5px", float: "right" }}
            shape="rounded"
            // hidePrevButton
            // hideNextButton
            count={totalPages}
            page={page}
            onChange={handlePageChange}
          />
        )}
      </TableContainer>
    </div>
  );
}
``;
